import React from "react"

const Form = props => (
  <form className="form" style={{ width: "100%" }} {...props}>
    {props.children}
  </form>
)

export default Form
